import { type FC } from 'react';

import { StyledBadge } from './Badge.styled';
import type { BadgeProps } from './types';

const Badge: FC<BadgeProps> = ({
  label,
  color = 'default',
  variant = 'solid',
  size = 'md',
  roundness = 'default',
  startIcon,
  endIcon,
  className,
}) => (
  <StyledBadge
    $color={color}
    $variant={variant}
    $size={size}
    $roundness={roundness}
    className={className}
  >
    {startIcon}
    {label}
    {endIcon}
  </StyledBadge>
);

Badge.displayName = 'Badge';

export default Badge;
